import React, {createContext, useContext, useState} from 'react';

const BookingContext = createContext();

/**
 * Hook để sử dụng BookingContext
 * Phải được sử dụng trong BookingProvider
 */
export const useBooking = () => {
    const context = useContext(BookingContext);
    if (!context) {
        throw new Error('useBooking must be used within a BookingProvider');
    }
    return context;
};

/**
 * Provider để quản lý dữ liệu đặt lịch khám
 * Cho phép các component chia sẻ thông tin đặt lịch
 */
export const BookingProvider = ({children}) => {
    // State lưu trữ dữ liệu đặt lịch
    const [bookingData, setBookingData] = useState({
        hospital: '', // Tên bệnh viện
        department: '', // Tên chuyên khoa
        doctor: '', // Tên bác sĩ
        service: '', // Dịch vụ y tế
        business_id: '', // ID bệnh viện (để fill trực tiếp)
        department_id: '', // ID chuyên khoa (để fill trực tiếp)
        user_id: '', // ID bác sĩ (để fill trực tiếp)
        user_name: '', // UserName (để call lấy ra giờ có ca trực)
    });

    /**
     * Cập nhật thông tin đặt lịch
     * @param {Object} data - Dữ liệu cần cập nhật
     */
    const setBookingInfo = data => {
        setBookingData(prev => ({
            ...prev,
            ...data,
        }));
    };

    /**
     * Xóa tất cả dữ liệu đặt lịch
     */
    const clearBookingData = () => {
        setBookingData({
            hospital: '',
            department: '',
            doctor: '',
            service: '',
            business_id: '',
            department_id: '',
            user_id: '',
            user_name: '',
        });
    };

    return (
        <BookingContext.Provider
            value={{
                bookingData,
                setBookingInfo,
                clearBookingData,
            }}>
            {children}
        </BookingContext.Provider>
    );
};
